import { TSwissPostConnectedEms } from 'redux/reducers/swissPost/types';
import { EIconButtons } from '../../ui/EasTable/EasTableRow/EasTableValue/constants';
import { ETableStructureAlign, ETableStructureType } from '../../ui/EasTable/types';

export const shipmentsStructure = [
	{
		name: 'Full Name',
		selector: 'full_name',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		filter: 'text',
		colSpan: 1,
		type: ETableStructureType.EM,
		value: (item: TSwissPostConnectedEms) => {
			return { id: item.em_id, name: item.full_name };
		},
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Contact Person',
		selector: 'contact_person',
		show: true,
		sortable: false,
		filterable: false,
		filter: 'text',
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Contact Email',
		selector: 'contact_email',
		show: true,
		sortable: false,
		filterable: false,
		filter: 'text',
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Registered Country',
		selector: 'registered_country',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY,
		align: ETableStructureAlign.LEFT,
	},
	// {
	// 	name: 'Activation Date',
	// 	selector: 'activation_date',
	// 	show: true,
	// 	sortable: true,
	// 	filterable: true,
	// 	filter: [
	// 		[DATES_ID.TODAY, DATES.TODAY],
	// 		[DATES_ID.YESTERDAY, DATES.YESTERDAY],
	// 		[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
	// 		[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
	// 		[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
	// 		[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
	// 		[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
	// 		[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
	// 		[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
	// 		[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
	// 	],
	// 	colSpan: 1,
	// 	type: 'date',
	// 	align: 'center',
	// },
	{
		name: 'IOSS MCG Project ID',
		selector: 'msg_project_id_ioss',
		show: true,
		sortable: false,
		filterable: false,
		filter: 'text',
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: 'left',
	},
	{
		name: 'DDP Project  ID',
		selector: 'msg_project_id_oss',
		show: true,
		sortable: false,
		filterable: false,
		filter: 'text',
		colSpan: 1,
		type: 'string',
		align: 'left',
	},
	{
		name: 'Franking License',
		selector: 'franking_license',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Swiss First Mile Client ID',
		selector: 'swiss_first_mile_client_id',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Swiss First Mile Client Secret',
		selector: 'swiss_first_mile_client_secret',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'actions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: [{ name: 'Edit' }, { name: 'Disable' }],
		buttonFilter: (item: TSwissPostConnectedEms) => {
			switch (item.is_enabled) {
				case true:
					return [
						{ name: 'Edit', icon: EIconButtons.EDIT },
						{ name: 'Disable', icon: EIconButtons.CANCEL, color: 'error.main' },
					];
				case false:
					return [
						{ name: 'Edit', icon: EIconButtons.EDIT },
						{ name: 'Enable', icon: EIconButtons.CHECK_CIRCLE },
					];
				default:
					return [
						{ name: 'Edit', icon: EIconButtons.EDIT },
						{ name: 'Disable', icon: EIconButtons.CANCEL, color: 'error.main' },
					];
			}
		},
	},
];
